import { render, staticRenderFns } from "./ApprovedInvoicesIndex.vue?vue&type=template&id=5cd67261&scoped=true&"
import script from "./ApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
export * from "./ApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedInvoicesIndex.vue?vue&type=style&index=0&id=5cd67261&prod&scoped=true&lang=css&"
import style1 from "./ApprovedInvoicesIndex.vue?vue&type=style&index=1&id=5cd67261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd67261",
  null
  
)

export default component.exports